import axios from "axios";
const API_URL = process.env.REACT_APP_BASE_URL_API;
const token = `Bearer ` + localStorage.getItem('token');
const createdBy =  localStorage.getItem('userId');
const updatedBy =  localStorage.getItem('userId');
const mailRoomId =  localStorage.getItem('mailRoomId');
const branch =(localStorage.userDetails) ? JSON.parse(localStorage.userDetails).branch : "";
// const tCode= Date.now().toString();
const config = {
  headers: {
    'Authorization': token,
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
}
};
const outwardlogdetailCreate = async (inwardLogData : Array<any>) => {
  await axios
    .post(API_URL + "login/authenticate", {
        
    }, config)
    .then((response) => {
      if (response.data.message) {               
        localStorage.setItem("userDetails", JSON.stringify(response.data.message));  
        localStorage.setItem('token', JSON.stringify(response.data.message.token).slice(1, -1));
        localStorage.setItem('userId', JSON.stringify(response.data.message.id));
        localStorage.setItem('mailRoomId', JSON.stringify(response.data.message.mailRoomId));
        localStorage.setItem('userRole', JSON.stringify(response.data.message.roles).slice(1, -1));
      }
      return response.data;
    }).catch((error)=>{
        console.log(error)
    });
}

const getServiceProviderbyPincode = (pincode:any, shipmentModeId :Number) => {
  const bodyParamter = {
    mailRoomId,
    branch,
    pincode,
    shipmentModeId
};
  return axios.post(API_URL + "vendorzone/getserviceprovider", bodyParamter, config).then(
    (response) => {
         console.log( "Service Provider Get ",response.data.message)
        return response.data.message
       
    }
)
    .catch(error => console.log(error))
}
const getServiceProviderDistinctbyPincode = (pincode:any, shipmentModeId :Number) => {
  const bodyParamter = {
    mailRoomId,
    branch,
    pincode,
    shipmentModeId
};
  return axios.post(API_URL + "vendorzone/getserviceproviderdetails", bodyParamter, config).then(
    (response) => {
         console.log( "Service Provider Get ",response.data.message)
        return response.data.message
       
    }
)
    .catch(error => console.log(error))
}
// change by nk
const getDrsOutward = async (drsNumber: any) => {

  return axios.get(API_URL + "drs/",config).then(
      (response) => {
          //  console.log( response.data.message)
          return response.data.message
         
      }
  )
      .catch(error => console.log(error))
      
}
const getDrsIdOutward = async (id:any) => {

  return axios.get(API_URL + "drs/",config).then(
      (response) => {
          //  console.log( response.data.message)
          return response.data.message
         
      }
  )
      .catch(error => console.log(error))
      
}
// post inward status

// const postupdateOutwarddetailstatus = async (
//   inwarddetailStatus:any,
//   receivedBy:String,
//   remark:String,
//   inwardDate:any,inwardTime:any,updatedBy:String,deliverySign:any) => {
//   const bodyParamter = {
      
//       inwarddetailStatus:inwarddetailStatus,
//       receivedBy:receivedBy,
//       remark:remark,
//       inwardDate:inwardDate,
//       inwardTime:inwardTime,
//       updatedBy:1,
//       deliverySign:"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"
     
//   };
//   // console.log(bodyParamter)
//   return axios
//       .post(API_URL + "inwarddetail/updateinwarddetailstatus", bodyParamter, config).then(
//           (response) => {
            
//               return response.data;
//           })
//           .catch(error => console.log(error));
         
// }

const getZonebyPincodeandProduct = (product :Number, pincode : any) => {
  const bodyParamter = {
    mailRoomId,
    branch,
    pincode,
    product
};
  return axios.post(API_URL + "vendorzone/getzonebypincodeandproduct", bodyParamter, config).then(
    (response) => {
        return response.data.message       
    }
)
    .catch(error => console.log(error))

}
const postoutwardData = (direct :Number, outwardType: number, batchNo :any, courierType :any, modeId:Number, 
  outwardDate :any, outwardTime :any, employeeTableId :Number, employeeName :string, employeeId :string,department: number, 
   costCenter :Number, refNo :any, AWB :any, consigneeId :any, consigneeName :string, 
   consigneeAreaName :string, consigneeBranchId :Number, consigneeCityName :string, consigneePhoneNumber:string, consigneeEmailId :string,
    consigneeStateName :string, consigneeZipCode:string, consigneeCountryCode:string, serviceProvider:Number, 
    productName :string, product : Number, zoneName:Number, boxlength:number, boxwidth :number, boxheight :number, volumetricWeight:number, 
     numberOfPieces : Number,weight :number, chargableWeight :number, netAmount:number,fuelCharges:number, otherCharges: number, GST :number, grossAmount :number,mailContent:string, 
     shipmentType:number, accountNo:Number,remark:string, deliveryTat :any, serviceStatus :any) => {
  const bodyParamter = {
    mailRoomId, direct, accountNo,
    branch,outwardType,employeeName, employeeId,numberOfPieces,
    batchNo, courierType, modeName: modeId, outwardDate, outwardTime, employeeTableId, department,costCenter,
    outwarddetailStatus : 0,
     refNo, AWB, consigneeId : Number(consigneeId), consigneeName, consigneeAreaName, consigneeBranchId, consigneeCityName, 
     consigneePhoneNumber, consigneeEmailId, consigneeStateName, consigneeZipCode, consigneeCountryCode, serviceProvider, productName, product, zoneName, boxlength, boxwidth, boxheight, volumetricWeight, weight, chargableWeight, 
     netAmount,fuelCharges, otherCharges, GST, grossAmount,mailContent, shipmentType,remark,deliveryTat: deliveryTat.toString(),serviceStatus,
     baseUrl:API_URL, createdBy
};
console.log(bodyParamter)
  return axios.post(API_URL + "outwarddetail/register", bodyParamter, config).then(
    (response) => {
        //  console.log( response.data.message)
        return response.data
       
    }
)
    .catch(error => console.log(error))
}
const putoutwardData = (direct :Number, outwardType: number, batchNo :any, courierType :any, modeId:Number, 
  outwardDate :any, outwardTime :any, employeeTableId :Number, employeeName :string, employeeId :string, department: number,
   costCenter :Number, refNo :any, AWB :any, consigneeId :any, consigneeName :string, 
   consigneeAreaName :string, consigneeBranchId :Number, consigneeCityName :string, consigneePhoneNumber:string, consigneeEmailId :string,
    consigneeStateName :string, consigneeZipCode:string, consigneeCountryCode:string, serviceProvider:Number, 
    productName :string, product : Number, zoneName:Number, boxlength:number, boxwidth :number, boxheight :number, volumetricWeight:number, 
     numberOfPieces : Number,weight :number, chargableWeight :number, netAmount:number,fuelCharges:number, otherCharges: number, GST :number, grossAmount :number,mailContent:string, 
     shipmentType:number, accountNo:Number,remark:string, deliveryTat :any, serviceStatus :any, id :number) => {
  const bodyParamter = {
    mailRoomId, direct, accountNo,
    branch,outwardType,employeeName, employeeId,numberOfPieces,
    batchNo, courierType, modeName: modeId, outwardDate, outwardTime, employeeTableId, department, costCenter,
    outwarddetailStatus : 0,
     refNo, AWB, consigneeId : Number(consigneeId), consigneeName, consigneeAreaName, consigneeBranchId, consigneeCityName, 
     consigneePhoneNumber, consigneeEmailId , consigneeStateName, consigneeZipCode, consigneeCountryCode, serviceProvider, productName, product, zoneName, boxlength, boxwidth, boxheight, volumetricWeight, weight, chargableWeight, 
     netAmount,fuelCharges, otherCharges, GST, grossAmount,mailContent, shipmentType,remark,  deliveryTat: deliveryTat.toString(), serviceStatus,
     baseUrl:API_URL,updatedBy
}; 
  return axios.put(API_URL + "outwarddetail/" + id, bodyParamter, config).then(
    (response) => {
        //  console.log( response.data.message)
        return response.data
       
    }
)
    .catch(error => console.log(error))
}


const getOutwardDetailsListdateWise = (outwardDate :any) => {
  const bodyParamter = {
    mailRoomId, 
    branch, outwardDate,
};
// console.log(bodyParamter)
  return axios.post(API_URL + "outwarddetail/", bodyParamter, config).then(
    (response) => {  
      if(response.data.statuscode ==="200"){      //  console.log( response.data.message)
        return response.data.message
      }
    }
)
    .catch(error => console.log(error))
}

const getOutwardDetailsById = (id: Number) => {
  
  return axios.get(API_URL + "outwarddetail/" + id, config).then(
    (response) => {  
      if(response.data.statuscode ==="200"){    
        return response.data.message
      }
    }
)
    .catch(error => console.log(error))
}

const getAdminMaterialList = (outwardDate :any) => {
  const bodyParamter = {
    mailRoomId, 
    branch,
    DateofDispatch1 : outwardDate,
};
// console.log(bodyParamter)
  return axios.post(API_URL + "adminmaterial/", bodyParamter, config).then(
    (response) => {  
      console.log("response.data.statuscode", response.data.statuscode)
      if(response.data.statuscode ==="200"){      //  console.log( response.data.message)
        return response.data.message
      }
    }
)
    .catch(error => console.log(error)) 
}
const travellinghistory= async (AWB:any) => {
  const bodyParamter = {
    mailRoomId,      
    branch,
    AWB
    };
  return await axios.post(API_URL + "outwarddetail/travellinghistory/", bodyParamter, config).then(
    (response) => {
      if (response.data.statuscode === "200") {   
        return response.data.message
      }
    }
  )
    .catch(error => console.log(error))
}
const getOutwardDetailsPendigintimationList = async (outwardDate:any) => {
  const bodyParamenters = {
    outwardDate,
    branch,
    mailRoomId   
  }
  return await axios.post(API_URL + "outwarddetail/pendingforemail" ,bodyParamenters, config).then(
    (response) => {
      if (response.data.statuscode === "200") {     
        return response.data.message
      }
    }
  )
    .catch(error => console.log(error))
}


const sendEmailNotification = async (outwardIdsByEmployee :any) => {
  const bodyParamenters = {
    mailRoomId,
    branch,
    outwardIdsByEmployee,
    createdBy,
    baseUrl : process.env.REACT_APP_PUBLIC_URL
  }
  console.log(bodyParamenters)
  return await axios.post(API_URL +"outwarddetail/getmail", bodyParamenters, config).then(
    (data) => {
      if(data.data.statuscode === '200'){
      return data.data.message;
      }
    }
  ).catch(error =>console.log(error))
}

const vendoraccount = async (serviceProviderId :Number) =>{
  const bodyParamenters = {
    mailRoomId,
    branch,
    serviceProviderId
  }
  return await axios.post(API_URL +"vendoraccount/" , bodyParamenters, config).then(
    (data) => {
      if(data.data.statuscode === '200'){
      return data.data.message;
      }
    }
  ).catch(error =>console.log(error))
}
const trackOnline = async (AwbNo :any) =>{
  return await axios.get("https://api.bluedart.com/servlet/RoutingServlet?handler=tnt&action=custawbquery&loginid=BOM30649&awb=awb&numbers=20529084553&format=xml&lickey=ejg9mnqsgjni2pug8isiomrrolqsinkv&verno=1&scan=1", config)
  .then((response)=>{
    console.log("response", response)
return response
  })
   
}

const getAwbNumberbyAutoComplte = (input : any) => {
  const bodyParamter = {
    mailRoomId,      
    branch,
    input
    };
return axios.post(API_URL + "outwarddetail/getawbNumber/", bodyParamter, config).then(
    (response) => {
        return response.data.message
    }
).catch(error => {return ""})  
}

const postStatus = (uploadData : any) =>{
  const bodyParamter = {
    mailRoomId,      
    branch,
    uploadData
    };
return axios.post(API_URL + "outwarddetail/uploadstatus/", bodyParamter, config).then(
    (response) => {
        return response.data.message
    }
).catch(error => {return ""})  
}

const deleteoutward = (id:Number) => {
  return axios.delete(API_URL + "outwarddetail/"+id,  config).then(
    (response) => {
        return response.data.message
    })
    .catch(error => console.log(error))

}
const importOutwards = async (outwarddetail :any) => {
  const chunkSize = 100; // Set the desired chunk size for each iteration
  const totalChunks = Math.ceil(outwarddetail.length / chunkSize);

  for (let i = 0; i < totalChunks; i++) {
  const startIndex = i * chunkSize;
  const endIndex = Math.min((i + 1) * chunkSize, outwarddetail.length);
  const chunkData = outwarddetail.slice(startIndex, endIndex);

  // Create a request payload with the current chunk data
  const requestData = {
    outwarddetail:chunkData,
    mailRoomId, branch
  };
  try {
      // Send the POST request to the server using Axios
       await axios.post(API_URL + "outwarddetail/import/", requestData, config)
      // Handle the response from the server if needed
  } catch (error) {
      // Handle errors if the request fails
      console.error(error);
  }
  }   
  return "Outward Details Imported"    
}

const getzonedetails =(serviceProviderId: number,shipmentModeId :any,  consigneeZipCode :any, product:any)=>{
  const bodyParamter = {
    mailRoomId,      
    branch,
    serviceProviderId,
    shipmentModeId :shipmentModeId , 
    pincode: consigneeZipCode,
    product
    };
return axios.post(API_URL + "vendorzone/getzoneandtat/", bodyParamter, config).then(
    (response) => {
        return response.data.message
    }
).catch(error => {return ""})  
}

const getdataforhdtracking = async (Fromdate:any,Todate:any,EmployeeId:Number,StatusId:Number,AWBNo:any,ModeId:any,DepartmentId:any,RouteId:any,serviceProviderId:any,product:any) => {
  const bodyParamter = {
    fromDate:Fromdate,
    toDate:Todate,
    employeeTableId:EmployeeId,
    mailRoomId, 
    outwarddetailstatus:StatusId,
    ModeId,
    DepartmentId, 
    branch,
    AWB:AWBNo,serviceProviderId
    };
  return await axios.post(API_URL + "outwarddetail/getdatafortracking", bodyParamter, config).then(
    (response) => {
      if (response.data.statuscode === "200") {     
        return response.data.message
      }
    }
  )
    .catch(error => console.log(error))
}

const OutwardDetailService = {
    outwardlogdetailCreate,
    getDrsOutward,
    getDrsIdOutward,
    deleteoutward,
    // postupdateOutwarddetailstatus,
    getServiceProviderbyPincode,
    getServiceProviderDistinctbyPincode,
    postoutwardData,
    putoutwardData,
    getOutwardDetailsListdateWise,
    getOutwardDetailsById,
    getZonebyPincodeandProduct,
    getAdminMaterialList,
    travellinghistory,
    vendoraccount,

    sendEmailNotification,
    getOutwardDetailsPendigintimationList,
    trackOnline,
    getAwbNumberbyAutoComplte,
    postStatus,
    importOutwards,
    getzonedetails,
    getdataforhdtracking
  }
  
  export default OutwardDetailService;